import React from 'react'
import { Tab } from '@headlessui/react'
import { WidgetCategoryLink } from '@/types'
import { TabButton, TabList, TabContainer, StyledLink } from './ThingsToDo.styles'
import { useRouter } from 'next/router'
import { toName } from '@/helpers/UrlHelper'
import { useContext } from 'react'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import { getUrlPrefix } from '@/helpers/UrlHelper'
import { Button, Heading } from '@big-red-group/storefront-common-ui'

type CategoryLinksProps = {
  categories: { name: string; link: string; subcategories?: WidgetCategoryLink[] | undefined }[]
  region: string
  seeMore: boolean
}

// TODO: more component tests
const CategoryLinks: React.FC<CategoryLinksProps> = ({ categories, region, seeMore }) => {
  const router = useRouter()
  const { lang } = router.query
  const defaultProperties = useContext(DefaultPropertiesContext)
  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)

  return (
    <>
      <Heading size="XL" as="h2">
        Other things to do in {toName(region)}
      </Heading>
      <Tab.Group>
        <TabList>
          <TabButton>All</TabButton>
          {categories
            .filter(({ subcategories }) => subcategories)
            .map(({ name }) => (
              <TabButton key={name}>{name}</TabButton>
            ))}
        </TabList>
        <Tab.Panels data-testid="categories-container">
          <TabContainer>
            {categories.map((category, index) => (
              <Button size="M" onClick={() => router.push(`${baseUrl}/${lang}/${region}/${category.link}`)} key={index}>
                {category.name}
              </Button>
            ))}
          </TabContainer>
          {categories.map((category) => {
            if (category.subcategories) {
              return (
                <TabContainer key={category.name}>
                  <Button
                    className="all-btn"
                    onClick={() => router.push(`${baseUrl}/${lang}/${region}/${category.link}`)}
                  >
                    All
                  </Button>
                  {category.subcategories.map((subcategory, index) => (
                    <Button
                      size="M"
                      onClick={() => router.push(`${baseUrl}/${lang}/${region}/${category.link}/${subcategory.link}`)}
                      key={index}
                    >
                      {subcategory.name}
                    </Button>
                  ))}
                </TabContainer>
              )
            }
            return null
          })}
        </Tab.Panels>
      </Tab.Group>
      <div style={{ display: seeMore ? 'block' : 'none', marginTop: '30px' }}>
        <StyledLink href={`${baseUrl}/${lang}/search/${region}`}>See more destinations</StyledLink>
      </div>
    </>
  )
}

export default CategoryLinks
